module.exports = __webpack_public_path__ + "img/3.beadace2.jpg";